import { render } from "./addInStoreTrack.vue?vue&type=template&id=56c4b660&scoped=true"
import script from "./addInStoreTrack.vue?vue&type=script&lang=js"
export * from "./addInStoreTrack.vue?vue&type=script&lang=js"

import "./addInStoreTrack.vue?vue&type=style&index=0&id=56c4b660&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c4b660"]])

export default __exports__